import React, { Component } from 'react'
import PropTypes from 'prop-types'

import BlankStateSection from 'components/BlankStateSection'
import Button from 'components/Button'
import FormField from 'components/forms/FormField'
import LoadingBubbles from 'components/LoadingBubbles'
import Modal from 'modals/Modal'

import PrintHandsImage from './assets/print.svg'
import styles from './styles.scss'

class BuildingAttachmentModal extends Component {
  componentDidUpdate(prevProps){
    const { building: prevBuilding } = prevProps
    const { building } = this.props

    if (prevBuilding && !building){
      this._downloadFile({ cancelCloseModal: true })
    }
  }

  _downloadFile = (options = {}) => {
    const { attachment: { links }, closeModalCallback } = this.props

    if (links && links.force_attachment) window.open(links.force_attachment)
    if (!options.cancelCloseModal) closeModalCallback()
  }

  _renderContent = () => {
    const {
      attachment: { links },
      building,
      fileKey,
    } = this.props

    if (!building && links){
      return (
        <div className={styles.content}>
          <BlankStateSection imageAlt="Print Hands" imageUrl={PrintHandsImage} style={{ marginLeft: 25 }}>
            <p>
              Congratulations. Your file is now available for download at the following url, or by clicking the
              download button below.
            </p>

            <FormField label="File Url">
              <input type="text" defaultValue={fileKey ? links[fileKey] : links.original_url} />
            </FormField>

            <p>
              <Button
                color="blue"
                onClick={this._downloadFile}
                size="medium"
                target="_blank"
                text="Download File"
              />
            </p>
          </BlankStateSection>
        </div>
      )
    }

    return (
      <div className={styles.content}>
        <BlankStateSection imageAlt="Print Hands" imageUrl={PrintHandsImage} style={{ marginLeft: 25 }}>
          <p>
            Have a quick break while we build your document. Larger, more image dense files require compiling to produce
            an optimized file that can be printed locally.
          </p>

          <p>
            Please wait while we build your file in the background. It should only take a few moments. If you
            experience any issues please contact support.
          </p>

          <p>
            <Button
              color="lightGrey"
              disabled
              icon={<LoadingBubbles color="#ffffff" />}
              size="medium"
              text="Please Wait..."
            />
          </p>
        </BlankStateSection>
      </div>
    )
  }

  render(){
    const { building, closeModalCallback, showModal } = this.props

    return (
      <Modal
        showModal={showModal}
        title={building ? 'Building File' : 'File Ready'}
        closeModalCallback={closeModalCallback}
      >
        {this._renderContent()}
      </Modal>
    )
  }
}

BuildingAttachmentModal.propTypes = {
  attachable: PropTypes.object.isRequired,
  attachment: PropTypes.object.isRequired,
  building: PropTypes.bool,
  closeModalCallback: PropTypes.func.isRequired,
  fileKey: PropTypes.string,
  showModal: PropTypes.bool,
}

export default BuildingAttachmentModal
